import {create} from 'zustand'
import { persist } from 'zustand/middleware'

/**
 * @param {}
 * @returns {void}
 */
export const utilityAndConfigStore = create(
  persist(
    (set, get) => ({
      theme: 'dark-theme',
      isNewToApp: true,
      message: {
        type: null,
        show: false,
        title: '',
        description: '',
        inLine: false,
        alert: false,
        timeout: 5000
      },
      loading: {
        active: false,
        proccessesCount: 0,
        timeout: 10000,
        internalLoading: false,
        overlayedLoading: false
      },
      _hasHydrated: false,
      startLoading: (loading) => {
        set((state) => ({ 
          loading: {
            ...state.loading,
            ...loading,
            active: true,
            proccessesCount: state.loading.proccessesCount + 1,
          }
        }));
      },
      stopALoadingProccess: (loading) => {
        set((state) => ({ 
          loading: {
            ...state.loading,
            ...loading,
            proccessesCount: state?.loading?.proccessesCount > 0 ? (state?.loading?.proccessesCount - 1) : 0
        }}));
      },
      stopAllLoadingProccess: () => {
        set({loading: { 
          active: false,
          proccessesCount: 0,
          timeout: 10000,
          internalLoading: false,
          overlayedLoading: false
        }});
      },
      setTheme: (theme) => {
        set({ theme })
      },
      toogleNewToApp: () => {
        set({ isNewToApp: false })
      },
      setMessage: ( message ) => {
        set({ message: { ...message }})
      },
      clearMessage: ( ) => {
        set({ message: {
          type: null,
          show: false,
          title: '',
          description: '',
          inLine: false,
          alert: false,
          timeout: 5000
        } })
      },
      setHasHydrated: (state) => {
        set({
          _hasHydrated: state
        });
      }
    }),
    {
      name: 'utilityAndConfig-storage',
      getStorage: () => localStorage,
      partialize: (state) => ({ 
        theme: state.theme,
        isNewToApp: state.isNewToApp
      }),
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true)
      }
    }

  )
)